import { IZipAction, IZipState } from './zip.types'
import { ZipConstants } from './zip.constants'
import { AlertConstants } from '../../alert/store/alert.constants'

export const initialZipState: IZipState = {
  zipCode: '',
  responseMessage: '',
  success: false,
  failure: false,
  cityAction: '',
  stateAction: '',
  alertMessage: '',
}

export function zipReducer(state: IZipState = initialZipState, action: IZipAction): IZipState {
  switch (action.type) {
    case ZipConstants.SET_ZIP_STATE:
      return { ...state, zipCode: action.zipCode, cityAction: action.cityAction, stateAction: action.stateAction }
    case ZipConstants.SET_ZIP_RESPONSE:
      return {
        ...state,
        ...action.zip,
      }
    case ZipConstants.SET_ALERT_MESSAGE:
      return { ...state, alertMessage: action.alertMessage }
    case AlertConstants.RESET_SHOW_ALERT:
      return { ...state, alertMessage: '' }
    default:
      return state
  }
}
